export const initialState = {
  menuOpen: false,
  theme: 'dark',
  shader: 'meshGradient',
  shaderCropped: false,
};

export function reducer(state, action) {
  const { type, value } = action;

  switch (type) {
    case 'setTheme':
      return { ...state, theme: value };
    case 'toggleTheme': {
      const newThemeId = state.theme === 'dark' ? 'light' : 'dark';
      return { ...state, theme: newThemeId };
    }
    case 'setShader':
      return { ...state, shader: value };
    case 'setShaderCropped':
      return { ...state, shaderCropped: value };
    case 'toggleMenu':
      return { ...state, menuOpen: !state.menuOpen };
    default:
      throw new Error();
  }
}
